import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Login.css';

async function loginUser(credentials) {
    // if (process.env.NODE_ENV === 'production') {
    //     base_url = window.location.href;
    // }
    // else {
    //     base_url = process.env.REACT_APP_API_URL
    // }

    // const fullUrl = new URL('/api/login', base_url).toString();

    //return fetch('http://localhost:8085/api/login', {
    return fetch('/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
    })
    .then(data => data.json())

 }


export default function Login({ setToken }) {
    const [username, setUserName] = useState();
    const [password, setPassword] = useState();

    const handleSubmit = async e => {
        e.preventDefault();
        const token = await loginUser({
            username,
            password
        });
        setToken(token);
        // var token1 = {token: 'ciao'}
        // setToken(token1);

    }

    return(
        <div className="full-page-form__container">
        <div className="login-wrapper">
            <h1>Please Log In</h1>
            <form onSubmit={handleSubmit} className="full-page-form__content">
                <label>
                    <p>Username</p>
                    <input type="text" onChange={e => setUserName(e.target.value)}/>
                </label>
                <label>
                    <p>Password</p>
                    <input type="password" onChange={e => setPassword(e.target.value)}/>
                </label>
                <div>
                    <button type="submit">Submit</button>
                </div>
            </form>
        </div>
        </div>
    )
}
Login.propTypes = {
    setToken: PropTypes.func.isRequired
}
